import { Col, Form, Row } from "react-bootstrap";
import ColorInput from "../ColorInput";
import FileInput from "../FileInput";
import ColorPickerAdd from "../ColorPickerAdd";
import ColorPickerClose from "../ColorPickerClose";

const FontsPanel = ({
  formData,
  setFormData,
  onInputChange,
  handleFileChange,
  fileNames,
  files,
  validate,
}) => {
  const gradientOptions = [
    { value: 1, label: "Top to Bottom" },
    { value: 2, label: "Left to Right" },
    { value: 3, label: "Top Left to Bottom Right" },
    { value: 4, label: "Top Right to Bottom Left" },
  ];

  const addBgColor = (name) => {
    if (name === "dropDownBgColor") {
      setFormData((prev) => ({
        ...prev,
        fontsPanel: {
          ...prev.fontsPanel,
          [name]: [...prev.fontsPanel[name], "#000000"],
        },
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        fontsPanel: {
          ...prev.fontsPanel,
          category: {
            ...prev.fontsPanel.category,
            selectedBgColor: [
              ...prev.fontsPanel.category.selectedBgColor,
              "#000000",
            ],
          },
        },
      }));
    }
  };

  const removeBgColor = (name, index) => {
    if (name === "dropDownBgColor") {
      setFormData((prev) => {
        const updatedBgColors = prev.fontsPanel[name].filter(
          (_, i) => i !== index
        );
        return {
          ...prev,
          fontsPanel: {
            ...prev.fontsPanel,
            [name]: updatedBgColors,
            dropDownBgOrientation:
              updatedBgColors.length === 1
                ? null
                : prev.fontsPanel.dropDownBgOrientation,
          },
        };
      });
    } else {
      setFormData((prev) => {
        const updatedBgColors = prev.fontsPanel.category.selectedBgColor.filter(
          (_, i) => i !== index
        );
        return {
          ...prev,
          fontsPanel: {
            ...prev.fontsPanel,
            category: {
              ...prev.fontsPanel.category,
              selectedBgColor: updatedBgColors,
              bgOrientation:
                updatedBgColors.length === 1
                  ? null
                  : prev.fontsPanel.category.bgOrientation,
            },
          },
        };
      });
    }
  };
  return (
    <Row className="g-3">
      <Col md={3}>
        <ColorInput
          label="Main Background Color"
          name="fontsPanel.mainBgColor"
          value={formData.fontsPanel.mainBgColor}
          onChange={onInputChange}
        />
      </Col>
      <Col md={3}>
        <ColorInput
          label="Separator Color"
          name="fontsPanel.separatorColor"
          value={formData.fontsPanel.separatorColor}
          onChange={onInputChange}
        />
      </Col>
      <Col md={3} sm={12}>
        <div className="d-flex align-items-center gap-4">
          <Form.Label>Dropdown Background Color</Form.Label>
          <ColorPickerAdd addBgColor={addBgColor} keyName="dropDownBgColor" />
        </div>
        <div className="d-flex align-items-center gap-3">
          {formData.fontsPanel.dropDownBgColor.map((color, index) => (
            <div key={index} className="position-relative">
              <ColorInput
                name="fontsPanel.dropDownBgColor"
                value={color}
                data-index={index}
                onChange={onInputChange}
              />
              {formData.fontsPanel.dropDownBgColor.length > 1 && (
                <ColorPickerClose
                  removeBgColor={removeBgColor}
                  index={index}
                  keyName="dropDownBgColor"
                />
              )}
            </div>
          ))}
        </div>
      </Col>
      {formData.fontsPanel.dropDownBgColor.length > 1 && (
        <Col md={3}>
          <Form.Group>
            <Form.Label htmlFor="fontsPanel.dropDownBgOrientation">
              Gradient Orientation
            </Form.Label>
            <Form.Select
              value={formData.fontsPanel.dropDownBgOrientation}
              id="fontsPanel.dropDownBgOrientation"
              name="fontsPanel.dropDownBgOrientation"
              onChange={onInputChange}
              className="my-2"
              required={formData.fontsPanel.dropDownBgColor.length > 1}
            >
              <option value="">Select Orientation</option>
              {gradientOptions.map((orientation) => (
                <option key={orientation.value} value={orientation.value}>
                  {orientation.label}
                </option>
              ))}
            </Form.Select>
            <Form.Control.Feedback type="invalid">
              Select any one gradient variant
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
      )}
      <Col md={3}>
        <ColorInput
          label="Switch Background Color"
          name="fontsPanel.switchBgColor"
          value={formData.fontsPanel.switchBgColor}
          onChange={onInputChange}
        />
      </Col>
      <Col md={3}>
        <Form.Group>
          <Form.Label>Opacity (Ex., 0.5)</Form.Label>
          <Form.Control
            type="text"
            name="fontsPanel.opacity"
            value={formData.fontsPanel.opacity}
            onChange={onInputChange}
            min={0}
            max={1}
            className="my-2"
          />
        </Form.Group>
      </Col>
      <Col md={6}>
        <FileInput
          label="Dropdown Image"
          name="dropDownImage"
          onChange={handleFileChange}
          required={true}
          fileName={fileNames.dropDownImage}
          accept="image/*"
          isInvalid={validate && !files.dropDownImage}
          feedback="Upload a dropdown image."
        />
      </Col>
      <Col md={12} className="mt-4">
        <h5 className="fw-bold">Category Style</h5>
        <Row className="g-3">
          <Col md={4}>
            <ColorInput
              label="Text Normal Color"
              name="fontsPanel.category.textNormalColor"
              value={formData.fontsPanel.category.textNormalColor}
              onChange={onInputChange}
            />
          </Col>
          <Col md={4}>
            <ColorInput
              label="Text Selected Color"
              name="fontsPanel.category.textSelectedColor"
              value={formData.fontsPanel.category.textSelectedColor}
              onChange={onInputChange}
            />
          </Col>
          <Col md={4} sm={12}>
            <div className="d-flex align-items-center gap-4">
              <Form.Label>Selected Background Color</Form.Label>
              <ColorPickerAdd
                addBgColor={addBgColor}
                keyName="selectedBgColor"
              />
            </div>
            <div className="d-flex align-items-center gap-3">
              {formData.fontsPanel.category.selectedBgColor.map(
                (color, index) => (
                  <div key={index} className="position-relative">
                    <ColorInput
                      name="fontsPanel.category.selectedBgColor"
                      value={color}
                      data-index={index}
                      onChange={onInputChange}
                    />
                    {formData.fontsPanel.category.selectedBgColor.length >
                      1 && (
                      <ColorPickerClose
                        removeBgColor={removeBgColor}
                        keyName="selectedBgColor"
                        index={index}
                      />
                    )}
                  </div>
                )
              )}
            </div>
          </Col>
          {formData.fontsPanel.category.selectedBgColor.length > 1 && (
            <Col md={4}>
              <Form.Group>
                <Form.Label htmlFor="fontsPanel.category.bgOrientation">
                  Gradient Orientation
                </Form.Label>
                <Form.Select
                  value={formData.fontsPanel.category.bgOrientation}
                  id="fontsPanel.category.bgOrientation"
                  name="fontsPanel.category.bgOrientation"
                  onChange={onInputChange}
                  className="my-2"
                  required={
                    formData.fontsPanel.category.selectedBgColor.length > 1
                  }
                >
                  <option value="">Select Orientation</option>
                  {gradientOptions.map((orientation) => (
                    <option key={orientation.value} value={orientation.value}>
                      {orientation.label}
                    </option>
                  ))}
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  Select any one gradient variant
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          )}
          <Col md={4}>
            <ColorInput
              label="Selected Border Color"
              name="fontsPanel.category.selectedBorderColor"
              value={formData.fontsPanel.category.selectedBorderColor}
              onChange={onInputChange}
            />
          </Col>
          <Col md={4}>
            <Form.Group>
              <Form.Label>Selected Border Width (px)</Form.Label>
              <Form.Control
                type="number"
                name="fontsPanel.category.selectedBorderWidth"
                value={formData.fontsPanel.category.selectedBorderWidth}
                onChange={onInputChange}
                min={0}
                 className="my-2"
              />
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group>
              <Form.Label>Corner Radius (px)</Form.Label>
              <Form.Control
                type="number"
                name={`fontsPanel.category.corners`}
                value={formData.fontsPanel.category.corners || 0}
                onChange={onInputChange}
                min={0}
                 className="my-2"
              />
            </Form.Group>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default FontsPanel;
